import { render } from "./indexChat.vue?vue&type=template&id=72b3e7a6"
import script from "./indexChat.vue?vue&type=script&lang=js"
export * from "./indexChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__